import { OutlinedInput, OutlinedInputProps, SxProps, Theme, useTheme } from "@mui/material"
import './OutlinedInputElement.scss'

interface OutlinedInputElementProps extends OutlinedInputProps {
}

export default function OutlinedInputElement(props: OutlinedInputElementProps) {
    const theme = useTheme()
    const { ...rest } = props
    const combineClassName = `${props?.className ?? ''} input-number-hidden-arrow `
    const combineStyle: SxProps<Theme> = {
        '& legend': { display: 'none' }, '& fieldset': { top: 0 },
        background: theme.palette.background.input, color: theme.palette.text.primary,
        ...props?.sx
    }
    return (
        <OutlinedInput
            {...rest}
            className={combineClassName}
            sx={combineStyle}
        />
    )
}